export default Object.freeze({
  CHECK_IN: 'check-in',
  CHECK_OUT: 'check-out'
});
